import React, { useEffect, useState } from "react";
import Navbar from "../../components/Navbar";
import Styles from "../../styles/exercise/listexercise.module.scss";
import { Link, useNavigate } from "react-router-dom";
import Create from "../../assets/exercise/create.png";
import Delete from "../../assets/exercise/delete.png";
import View from "../../assets/exercise/view.png";
import { useDispatch, useSelector } from "react-redux";
import Close_Button from "../../assets/auth/close.png";
import Suceess from "../../assets/exercise/deletepopup.png";
import Swal from "sweetalert2";
import { toggle } from "../../redux";
import InfiniteScroll from "react-infinite-scroll-component";
import { FaSearch } from "react-icons/fa";
import { coachRoutes } from "../../routers/CoachRouters";
import { deleteCoach, getCoachs } from "../../services";
import { getCoachProfile } from "../../services/coachService";

const capitalizeEachWord = (string) => {
  if (!string) return "";
  return string
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};
const LIMIT = 7;

const ListCoach = () => {
  const isSidebarOpen = useSelector((state) => state.navbar.button);
  const { profile } = useSelector((state) => state.coach);

  const dispatch = useDispatch();
  const [displayedCoaches, setDisplayedCoaches] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [sortOrder, setSortOrder] = useState("latest");

  const handleMainContainerClick = () => {
    if (isSidebarOpen) {
      dispatch(toggle());
    }
  };
  const navigate = useNavigate();

  const fetchCoaches = async (pageNum = page, query = "", sort = sortOrder) => {
    if (loading) return;

    try {
      setLoading(true);
      console.log("Fetching Coaches for page:", page);

      const newCoaches = await getCoachs(false, pageNum, LIMIT, query);

      if (newCoaches && Array.isArray(newCoaches) && newCoaches.length > 0) {
        setDisplayedCoaches((prev) => [...prev, ...newCoaches]);
        setPage((prev) => prev + 1);
        console.log("Fetched new Coaches:", newCoaches.length);
      } else {
        console.log("No more Coaches to fetch");
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching Coaches:", error);
      setHasMore(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = () => {
      fetchCoaches();
      getCoachProfile();
    };
    fetchData();
  }, []);

  const handleSearch = async (e, sort = sortOrder) => {
    const query = e.target.value;
    setSearchQuery(query);

    try {
      if (query.trim() === "") {
        setDisplayedCoaches([]);
        setPage(1);
        setHasMore(true);
        setTimeout(() => {
          fetchCoaches(1, "", sort);
        }, 1);
      } else {
        const newCoaches = await getCoachs(false, 1, -1, query, sort);
        if (Array.isArray(newCoaches)) {
          setDisplayedCoaches(newCoaches);
          setHasMore(false);
        }
      }
    } catch (error) {
      console.error("Search error:", error);
    }
  };

  const handleDelete = (id) => {
    Swal.fire({
      html: `
        <div style="text-align: center; border-radius: 20px; position: relative;">
          <button
            id="customCloseButton"
            style="position: absolute; top:-5px; right:-10px; background: none; border: none; cursor: pointer;">
            <img
              src=${Close_Button}
              alt="Close"
              style="width: 40px; height: 40px;"
            />
          </button>
          <img
            src=${Suceess}
            alt="Success"
            style="width: 100px; margin-bottom: 10px; margin-top: 15px;"
          />
          <h2 style="color:#151515;text-align:center;font-family:gothambold; font-size:18px;margin-bottom: 10px; ">Are you sure?</h2>
          <p style="color:#2E292A;text-align:center;font-family:gotham_bookregular; line-height:22px; font-size:14px;margin-bottom: 10px; ">
            Do you really want to delete these details? This process cannot be undone.
          </p>
          <button
            id="cancel"
            style="background: linear-gradient(0deg, #151515 0%, #525252 100%); color: #f3f3f6; padding: 10px 50px; font-size: 14px; font-family:gothambold; border: none; border-radius: 6px; cursor: pointer; margin-top: 10px;">
            Cancel
          </button>
          <br/>
          <button
            id="delete"
            style="background: #800505; color: #f3f3f6; padding: 10px 50px; font-size: 14px; font-family:gothambold; border-radius: 6px; cursor: pointer; margin-top: 10px;">
            Delete
          </button>
        </div>
      `,
      showConfirmButton: false,
      width: "400px",
      customClass: {
        popup: "custom-swal-container",
      },
      didOpen: () => {
        const cancel = document.getElementById("cancel");
        const deleteButton = document.getElementById("delete");
        const closeButton = document.getElementById("customCloseButton");

        cancel.addEventListener("click", () => {
          Swal.close();
        });
        deleteButton.addEventListener("click", async () => {
          Swal.close();
          const success = await deleteCoach(id);
          if (success) {
            window.location.reload(coachRoutes.listExercise);
          }
        });

        closeButton.addEventListener("click", () => {
          Swal.close();
        });
      },
    });
  };

  return (
    <>
      <Navbar />
      <div
        className={Styles.exercise_list_container_main}
        onClick={handleMainContainerClick}
      >
        <h2>
          <Link to={coachRoutes.dashboard}>HOME / </Link> <span>ALL COACH</span>
        </h2>
        <div className={Styles.exercise_list_container}>
          <div className={Styles.table_container_heading}>
            <div className={Styles.table_container_headingone}>
              <h3>COACH &nbsp;LIST</h3>
            </div>
            <div className={Styles.table_container_headingtwo}></div>
          </div>
          <div className={Styles.tableFixedHeader}>
            <div className={Styles.scrollableWrapper}>
              <table className={Styles.exercise_table}>
                <thead>
                  <tr>
                    <th style={{ width: "15%" }}>Name</th>
                    <th style={{ width: "15%" }}>Gym</th>
                    <th style={{ width: "15%" }}>Phone</th>
                    <th style={{ width: "20%" }}>Email</th>
                    <th style={{ width: "30%", textAlign: "center" }}>
                      Action
                    </th>
                  </tr>
                </thead>
              </table>
              <div id="scrollableDiv" className={Styles.scrollableContainer}>
                {!displayedCoaches || displayedCoaches.length === 0 ? (
                  <div className={Styles.no_sessions_container}>
                    <p
                      style={{
                        textAlign: "center",
                        padding: "10px",
                        color: "#f3f3f6",
                        fontFamily: "vanguard_cf_regular",
                      }}
                    >
                      No Coaches available
                    </p>
                  </div>
                ) : (
                  <InfiniteScroll
                    dataLength={displayedCoaches.length}
                    next={fetchCoaches}
                    hasMore={hasMore}
                    loader={<></>}
                    endMessage={
                      <p
                        style={{
                          textAlign: "center",
                          padding: "10px",
                          color: "#f3f3f6",
                          fontFamily: "gotham_bookregular",
                        }}
                      ></p>
                    }
                    scrollableTarget="scrollableDiv"
                    scrollThreshold={0.8}
                  >
                    <table className={Styles.exercise_table}>
                      <tbody>
                        {displayedCoaches.map((coach) => {
                          const isDeleteDisabled =
                            profile.role !== "HeadCoach" ||
                            profile._id === coach._id;

                          return (
                            <tr key={coach.id}>
                              <td style={{ width: "15%" }}>
                                {capitalizeEachWord(coach.name)}
                              </td>
                              <td style={{ width: "15%" }}>{coach.gym.name}</td>
                              <td style={{ width: "15%" }}>{coach.phone}</td>
                              <td style={{ width: "20%" }}>{coach.email}</td>
                              <td style={{ width: "30%" }}>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <button
                                    className={`${Styles.delete_btn} ${
                                      isDeleteDisabled
                                        ? Styles.disabled_btn
                                        : ""
                                    }`}
                                    onClick={() => handleDelete(coach._id)}
                                    disabled={isDeleteDisabled}
                                    style={{
                                      opacity: isDeleteDisabled ? 0.5 : 1,
                                      cursor: isDeleteDisabled
                                        ? "not-allowed"
                                        : "pointer",
                                    }}
                                  >
                                    <img
                                      src={Delete}
                                      alt="Delete Icon"
                                      className={Styles.delete_icon}
                                    />{" "}
                                    Delete
                                  </button>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </InfiniteScroll>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ListCoach;
